import { createAsyncThunk } from '@reduxjs/toolkit'

import { APIError, get, post } from '@user/store/services/crud'
import { DashboardAgreement } from './typings'
import {
  ISearchResponse,
  pageToSearchInput,
  searchInputToQueryString,
} from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { ManageAgreementsInput } from './typings'
import {
  DashboardSettingsResponseType,
  IUserPreferenceDashboard,
} from '@user/store/userPreferences/typings'

export const getAgreements = createAsyncThunk<
  ISearchResponse<DashboardAgreement>,
  { page: number; query?: string },
  { rejectValue: APIError }
>('dashboard/agreements/getData', async ({ page, query }, thunkApi) => {
  const agreementsPerPage = 3
  const qstring = searchInputToQueryString(
    pageToSearchInput(page, agreementsPerPage, query),
  )
  const response = await get(
    `${ServiceConfig.baseAPIUrl}/Dashboard/agreements?${qstring}`,
  )

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const postData = createAsyncThunk<
  IUserPreferenceDashboard,
  ManageAgreementsInput
>(
  'usersPreferences/Dashboard/manageAgreements/post',
  async (userPref, thunkApi) => {
    const response = await post(
      `${ServiceConfig.baseAPIUrl}/UserPreferences/dashboard`,
      userPref,
    )
    if (response.ok) {
      const result: IUserPreferenceDashboard = await response.json()
      return result
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const getAgreementWidgetSettingsData =
  createAsyncThunk<DashboardSettingsResponseType>(
    'usersPreferences/Dashboard/manageAgreements/settings',
    async (_, thunkApi) => {
      const response = await get(
        `${ServiceConfig.baseAPIUrl}/UserPreferences/Dashboard/Type/MC`,
      )
      if (response.ok) {
        const result: DashboardSettingsResponseType = await response.json()
        return result
      }
      return thunkApi.rejectWithValue(await response.json())
    },
  )
